module.exports = __webpack_public_path__ + "6453964a8ed50bc2783e6da86e605220.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fee-confirm-guide-2.png
// module id = 1310
// module chunks = 61